import { type LabProfile, type UpdateLabProfileInput, letterheadLines } from '#shared/types';
import { dash } from '#client/lib/format';

/** The saved profile as form values, with stored nulls as empty text. */
export function initialCompanyValues(profile: LabProfile): UpdateLabProfileInput {
  return {
    name: profile.name,
    tagline: profile.tagline ?? '',
    address_line1: profile.address_line1 ?? '',
    address_line2: profile.address_line2 ?? '',
    city: profile.city ?? '',
    phone_primary: profile.phone_primary ?? '',
    phone_secondary: profile.phone_secondary ?? '',
    email: profile.email ?? '',
    website: profile.website ?? '',
    license_no: profile.license_no ?? '',
    ntn_no: profile.ntn_no ?? '',
    logo_data_url: profile.logo_data_url,
  };
}

/**
 * The letterhead as one line, or a dash when nothing is filled in.
 *
 * The same function the printed documents compose their letterhead with, so
 * the preview cannot disagree with the paper.
 */
export function letterheadPreview(values: UpdateLabProfileInput): string {
  return dash(letterheadLines(values).join(' · '));
}
